import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import InputMask from 'react-input-mask';
import headerLogo from "./../../Registration/img/header-logo.svg";
import userIconForm from "./../../Registration/img/user-icon-form.svg";
import barcodeReadIconForm from "./../../Registration/img/barcode-read-icon-form.svg";
import barcodeAltIconForm from "./../../Registration/img/barcode-alt-icon-form.svg";
import forgotPasswordIcon from './../../Registration/img/forgot-password.svg';
import { translate } from 'react-i18next';
import { request } from './../../../config';
import { Switch } from '@mui/joy';
import OutsideClickHandler from 'react-outside-click-handler';
import { phoneIconForm } from './../../Login/img/phone-icon-form.svg';
import AsanVerification from '../../../copms/Modal/AsanVerification';

class CheckForgotPass extends Component {
    state = {
        customerType: 'Individual',
        feedbackMessage: null,
        isDisabled: true,
        pin: '',
        mobile: '',
        taxNo: '',
        validateTaxNo: false,
        validatePin: false,
        validateMobile: false,
        isForeigner: false,
        docSeries: null,
        docNumber: '',
        validateSeries: false,
        dropdownVisibilitySerials: false,
        selectedSerialIndex: -1,
        selectedSerialIndexCount: 0,
        serials: [],
        serialNumberOutline: false,
        pinOutline: false,
        step: 1,
        userId: '',
        phoneNumber: '',
        validateUserId: false,
        validatePhoneNumber: false
    }
    backLogin = () => {
        if (this.state.customerType === 'Juridical') {
            this.props.history.push('/login/juridical/mobile');
        }
        else {
            this.props.history.push('/login/individual/mobile');
        }
    }
    handlePinChange = (value) => {
        const mask = this.state.isForeigner ? /[^a-zA-Z0-9-]/g : /[^a-zA-Z0-9]/g;
        const normalizedPin = value.replace(mask, '').toUpperCase();
        const finalPin = this.state.isForeigner ? normalizedPin.substring(0, 30) : normalizedPin.substring(0, 7);
        this.setState({ pin: finalPin }, () => {
            if (this.state.isForeigner) {
                const valid = finalPin.length > 0 && finalPin.length <= 30;
                this.setState({ validatePin: valid, pinOutline: finalPin.length === 0 }, this.updateDisabledState);
            } else {
                const valid = finalPin.length >= 5 && finalPin.length <= 7;
                this.setState({ validatePin: valid, pinOutline: finalPin.length < 7 }, this.updateDisabledState);
            }
        });
    }

    handleMobileChange = (value) => {
        this.setState({ mobile: value }, () => {
            setTimeout(() => {
                const valid = value.indexOf("_") === -1;
                this.setState({ validateMobile: valid }, this.updateDisabledState);
            }, 1);
        });
    }

    handleTaxNoChange = (value) => {
        let sanitized = value.replace(/[^0-9]/g, '');
        if (sanitized.length > 10) {
            sanitized = sanitized.substring(0, 10);
        }
        this.setState({ taxNo: sanitized }, () => {
            if (sanitized.length < 10) {
                this.setState({ validateTaxNo: false }, this.updateDisabledState);
            } else {
                this.setState({ validateTaxNo: true }, this.updateDisabledState);
            }
        });
    }

    handleUserIdChange = (value) => {
        const sanitized = value.replace(/\D/g, '').substring(0, 6);
        this.setState({ userId: sanitized }, () => {
            const valid = sanitized.length === 6;
            this.setState({ validateUserId: valid });
            setTimeout(() => {
                if (this.state.validateUserId && this.state.validatePhoneNumber) {
                    this.setState({ isDisabled: false });
                } else {
                    this.setState({ isDisabled: true });
                }
            }, 1);
        });
    }

    handlePhoneNumberChange = (value) => {
        this.setState({ phoneNumber: value }, () => {
            setTimeout(() => {
                const valid = value.indexOf("_") === -1;
                this.setState({ validatePhoneNumber: valid });
                setTimeout(() => {
                    if (this.state.validateUserId && this.state.validatePhoneNumber) {
                        this.setState({ isDisabled: false });
                    } else {
                        this.setState({ isDisabled: true });
                    }
                }, 1);
            }, 1);
        });
    }

    updateDisabledState = () => {
        const {
            customerType,
            validatePin,
            validateMobile,
            validateTaxNo,
            validateSeries,
        } = this.state;

        let baseValid;
        if (customerType === 'Juridical') {
            baseValid = validatePin && validateTaxNo && validateMobile;
        } else {
            baseValid = validateSeries && validatePin && validateMobile;
        }
        this.setState({ isDisabled: !(baseValid) });
    }

    handleNationalityChange = (event) => {
        const isForeigner = event.target.checked;
        this.setState(
            {
                isForeigner,
                pin: '',
                docSeries: null,
                docNumber: '',
                validateSeries: false,
                validatePin: false,
                pinOutline: false,
                serialNumberOutline: false,
                selectedSerialIndex: -1,
                selectedSerialIndexCount: 0,
            },
            () => {
                this.loadSerialCodes(isForeigner);
                this.updateDisabledState();
            }
        );
    }

    getMobile = (mobile) => {
        ['+', '-', '(', ')', ' '].forEach(char => {
            while (mobile.indexOf(char) !== -1) {
                mobile = mobile.slice(0, mobile.indexOf(char)) + mobile.slice(mobile.indexOf(char) + 1, mobile.length);
            }
        });
        return mobile;
    }

    loadSerialCodes = (isForeigner) => {
        fetch(request(`util/getSerialCodes?isForeign=${isForeigner ? 1 : 0}`, null, "POST"))
            .then(res => res.text())
            .then((serialResponseJSON) => {
                const JSON = require('true-json-bigint');
                let serialResponse = JSON.parse(serialResponseJSON);
                let serials = serialResponse;

                if (serialResponse && typeof serialResponse === 'object') {
                    serials = serialResponse.serials ?? serialResponse.payload ?? serialResponse.data ?? serialResponse.serialCodes ?? serialResponse;
                }

                if (!Array.isArray(serials)) {
                    serials = Object.values(serials);
                }

                serials = Array.isArray(serials)
                    ? serials.map(item => typeof item === 'object' && item !== null ? (item.code ?? item.serial ?? item.value ?? '') : item).filter(Boolean)
                    : [];

                this.setState({ serials });
            })
            .catch(() => {
                this.setState({ serials: [] });
            });
    }

    getAsanAuthForgotPass = (e) => {
        e.preventDefault();
        this.props.updateAppState('isLoadingTransparentBackground', true);

        let getAsanAuthRequestBody = {
            pin: this.state.pin,
            userId: this.state.userId,
            mobile: this.getMobile(this.state.phoneNumber),
            taxNo: this.state.taxNo,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isForeigner: this.state.isForeigner,
        }

        fetch(request("register/getAsanAuthForgotPassJuridical", getAsanAuthRequestBody))
            .then(res => res.text())
            .then((getAsanAuthResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getAsanAuthResponse = JSON.parse(getAsanAuthResponseJSON);
                if (getAsanAuthResponse.status.statusCode !== 1) {
                    if (getAsanAuthResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.setState({
                            feedbackMessage: this.props.t(getAsanAuthResponse.status.statusCode),
                            isDisabled: true
                        });
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ verificationOpen: true, verificationCode: getAsanAuthResponse.verificationCode })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let signFileRequestBody = {
                        token: getAsanAuthResponse.token,
                        lang: localStorage.getItem('i18nextLng').toUpperCase(),
                        sessionId: getAsanAuthResponse.sessionId,
                        userId: this.state.userId,
                        mobile: this.getMobile(this.state.phoneNumber),
                    }
                    fetch(request("register/confirmAsanForgotPassJuridical", signFileRequestBody))
                        .then(res => res.text())
                        .then((signFileResponseJSON) => {
                            const JSON = require('true-json-bigint');
                            let signFileResponse = JSON.parse(signFileResponseJSON);
                            if (signFileResponse.status.statusCode !== 1) {
                                if (signFileResponse.status.statusCode === 200) {
                                    this.props.logout();
                                } else {
                                    this.setState({ verificationOpen: false });
                                    this.setState({
                                        feedbackMessage: this.props.t(signFileResponse.status.statusCode),
                                        isDisabled: true
                                    });
                                }
                            } else {
                                this.props.history.push('/login/juridical/mobile/forgot-password/3', { token: signFileResponse.token });
                            }
                        });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    checkData = (event) => {
        event.preventDefault();
        this.props.updateAppState('isLoadingTransparentBackground', true);

        const seriesPayload = {
            docSeries: this.state.docSeries,
            docNumber: this.state.docNumber
        };

        let checkCostumerRequestBody = this.state.customerType === 'Juridical' ? {
            pin: this.state.pin,
            mobile: this.getMobile(this.state.mobile),
            taxNo: this.state.taxNo,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            isForeigner: this.state.isForeigner,
        } :
            {
                pin: this.state.pin,
                mobile: this.getMobile(this.state.mobile),
                lang: localStorage.getItem('i18nextLng').toUpperCase(),
                isForeigner: this.state.isForeigner,
                ...seriesPayload,
            }
        fetch(request("register/checkForgotPass" + this.state.customerType + "v2", checkCostumerRequestBody))
            .then(res => res.text())
            .then((checkCustomerRequestResponseJSON) => {
                const JSON = require('true-json-bigint');
                let checkCustomerRequestResponse = JSON.parse(checkCustomerRequestResponseJSON);
                if (checkCustomerRequestResponse.status.statusCode !== 1) {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.setState({
                        feedbackMessage: this.props.t(checkCustomerRequestResponse.status.statusCode),
                        isDisabled: true
                    });
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    if (this.state.customerType === 'Juridical') {
                        this.setState({ step: 2, isDisabled: true, feedbackMessage: null });
                        // this.getAsanAuthForgotPass(checkCostumerRequestBody);
                        // this.props.history.push('    /login/juridical/mobile/forgot-password/2', { checkCostumerRequestBody, verifyToken: checkCustomerRequestResponse.verifyToken });
                    }
                    else {
                        this.props.history.push('/login/individual/mobile/forgot-password/2', { checkCostumerRequestBody, verifyToken: checkCustomerRequestResponse.verifyToken });
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                }
            )
    }

    onChangeSerialNumber(val) {
        if (this.state.isForeigner) {
            if (val.length <= 30) {
                this.setState({
                    docNumber: val,
                    serialNumberOutline: val.length === 0,
                    validateSeries: this.state.selectedSerialIndex >= 0 && val.length > 0
                }, this.updateDisabledState);
            }
        } else {
            if (/^[0-9]*$/.test(val) || val.length === 0) {
                const valid = this.state.selectedSerialIndex >= 0 && val.length === 7;
                this.setState({
                    docNumber: val,
                    serialNumberOutline: val.length === 0 || val.length < 7,
                    validateSeries: valid
                }, this.updateDisabledState);
            }
        }
    }

    componentDidMount() {
        if (this.props.match.url === '/login/juridical/mobile/forgot-password/1') {
            this.setState({ customerType: 'Juridical' }, () => this.loadSerialCodes(this.state.isForeigner));
        }
        else if (this.props.match.url === '/login/individual/mobile/forgot-password/1') {
            this.setState({ customerType: 'Individual' }, () => this.loadSerialCodes(this.state.isForeigner));
        } else {
            this.loadSerialCodes(this.state.isForeigner);
        }
    }

    render() {
        let { feedbackMessage, isDisabled, customerType, isForeigner, selectedSerialIndexCount,
            selectedSerialIndex, dropdownVisibilitySerials, serialNumberOutline, docNumber, pinOutline, step,
            verificationOpen, verificationCode, serials } = this.state;
        let { t } = this.props;
        return (
            <div className="registration">
                <AsanVerification open={verificationOpen} verificationCode={verificationCode} />
                <Link to="/">
                    <img src={headerLogo} className="registration-logo" alt="headerLogo" />
                </Link>
                <form className="registration-container registration-container--top-border">
                    <h2 className="registration-container-title">{t('forget password')}</h2>
                    <p className="registration-container-description">{t('enter your mobile number to continue')}</p>
                    <img src={forgotPasswordIcon} className="registration-container-icon" alt="forgotPasswordIcon" />
                    {step === 1 ?
                        <>
                            <div className="registration-container-form-grid flex-wrap">
                                <div className={"registration-container-form-group registration-container-form-group-grid" + (customerType === 'Juridical' ? " w-100" : "")}>
                                    <label className="registration-container-form-group-label">{t('check non-resident')}</label>
                                    <Switch checked={isForeigner} onChange={this.handleNationalityChange} />
                                </div>
                                <div className="registration-container-form-group registration-container-form-group-grid">
                                    <label className="registration-container-form-group-label">{t('fin code of the id card')}</label>
                                    <div className={"registration-container-form-group-box" + (pinOutline ? " input-outline" : "")}>
                                        <input type="text" className="registration-container-form-group-box-input" value={this.state.pin} placeholder={t('enter the fin code')} onChange={(e) => this.handlePinChange(e.target.value)} />
                                        <div className="registration-container-form-group-box-icon">
                                            <img src={barcodeReadIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__user" alt="" />
                                        </div>
                                    </div>
                                </div>
                                {customerType === 'Individual' && (
                                    <>
                                        <div className="dashboard-payment-container-data-section-content-container-form-input-group dashboard-payment-container-data-section-content-container-form-input-group__grid">
                                            <label className="dashboard-payment-container-data-section-content-container-form-label">{t('ID number')}</label>
                                            <div className="d-flex justify-content-between">
                                                <OutsideClickHandler onOutsideClick={() => { this.setState({ dropdownVisibilitySerials: false }) }}>
                                                    <div style={{ width: '90px' }} className={"mr-2 dashboard-payment-container-data-section-content-container-form-select-box " + ((selectedSerialIndexCount > 1 && selectedSerialIndex < 0) || (selectedSerialIndexCount === 1 && selectedSerialIndex < 0 && !dropdownVisibilitySerials) ? "input-outline" : "")}>
                                                        <button className={"dashboard-payment-container-data-section-content-container-form-select-box-button"} onClick={e => { e.preventDefault(); this.setState({ dropdownVisibilitySerials: !dropdownVisibilitySerials }); if (selectedSerialIndex < 0) this.setState({ selectedSerialIndexCount: this.state.selectedSerialIndexCount + 1 }) }}>
                                                            <div className="dashboard-payment-container-data-section-content-container-form-select" style={{ color: selectedSerialIndex < 0 ? '#BDC3C7' : undefined }}>{selectedSerialIndex >= 0 ? serials[selectedSerialIndex] : t('Choose')}</div>
                                                            <div className="dashboard-payment-container-data-section-content-container-form-icon">
                                                                <svg className="dashboard-payment-container-data-section-content-container-form-icon-img" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path id="chevron-down copy 2" d="M12.4336 1.34375L11.9141 0.796875C11.7773 0.660156 11.5586 0.660156 11.4492 0.796875L6.5 5.74609L1.52344 0.796875C1.41406 0.660156 1.19531 0.660156 1.05859 0.796875L0.539063 1.34375C0.402344 1.45312 0.402344 1.67188 0.539063 1.80859L6.25391 7.52344C6.39063 7.66016 6.58203 7.66016 6.71875 7.52344L12.4336 1.80859C12.5703 1.67187 12.5703 1.45312 12.4336 1.34375Z" fill="#849097" />
                                                                </svg>
                                                            </div>
                                                        </button>
                                                        {
                                                            serials.length !== 0 &&
                                                            <ul className={(dropdownVisibilitySerials === false) ? "dashboard-payment-container-data-section-content-container-form-select-box-list dashboard-payment-container-data-section-content-container-form-select-box-list__hidden" : "dashboard-payment-container-data-section-content-container-form-select-box-list"}>
                                                                {
                                                                    serials.map((item, index) => (
                                                                        <li className="dashboard-payment-container-data-section-content-container-form-select-box-list-item" key={index}>
                                                                            <button type="button" className="dashboard-payment-container-data-section-content-container-form-select-box-list-item-button" onClick={e => {
                                                                                e.preventDefault(); this.setState({ selectedSerialIndex: index, docSeries: item, dropdownVisibilitySerials: false, validateSeries: this.state.docNumber?.length > 0 && (!isForeigner ? this.state.docNumber.length === 7 : true) }, this.updateDisabledState)
                                                                            }}>{item}</button>
                                                                        </li>
                                                                    ))
                                                                }
                                                            </ul>
                                                        }
                                                    </div>
                                                </OutsideClickHandler>
                                                <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                                                    <div className={"dashboard-payment-container-data-section-content-container-form-input-box " + (serialNumberOutline ? "input-outline" : "")}>
                                                        <input type="text" maxLength={isForeigner ? 30 : 10} value={docNumber} onChange={e => this.onChangeSerialNumber(e.target.value)} placeholder={isForeigner ? t('XXXXX') : '12345678'}
                                                            className="dashboard-payment-container-data-section-content-container-form-input dashboard-payment-container-data-section-content-container-form-input__whole" />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <label className="dashboard-payment-container-data-section-content-container-form-label my-0" style={{ color: '#8E8E8E' }}>{t('If your ID information has changed, please provide the new ID number.')}</label> */}
                                        </div>
                                    </>
                                )}
                                <div className="registration-container-form-group registration-container-form-group-grid">
                                    <label className="registration-container-form-group-label">{t('phone number')}</label>
                                    <div className="registration-container-form-group-box">
                                        <InputMask mask="+\9\9\4 ( 99 ) 999-99-99" className="registration-container-form-group-box-input" value={this.state.mobile} placeholder="+994 (__) ___-__-__" onChange={(e) => this.handleMobileChange(e.target.value)} />
                                        <div className="registration-container-form-group-box-icon">
                                            <img src={userIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__user" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                customerType === 'Juridical' ?
                                    <div className="registration-container-form">
                                        <div className="registration-container-form-group">
                                            <label className="registration-container-form-group-label">{t('tin')}</label>
                                            <div className="registration-container-form-group-box">
                                                <input type="text" className="registration-container-form-group-box-input" value={this.state.taxNo} placeholder={t('enter the tin')} onChange={(e) => this.handleTaxNoChange(e.target.value)} />
                                                <div className="registration-container-form-group-box-icon">
                                                    <img src={barcodeAltIconForm} className="registration-container-form-group-box-icon-img registration-container-form-group-box-icon-img__user" alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    null
                            }
                        </> :
                        <>
                            <div className="header-sign-section-container-form-group">
                                <label className="header-sign-section-container-form-group-label">{t('phone number')}</label>
                                <div className="header-sign-section-container-form-group-box">
                                    <InputMask mask="+\9\9\4 ( 99 ) 999-99-99" className="header-sign-section-container-form-group-box-input" value={this.state.phoneNumber} placeholder="+994 (__) ___-__-__" onChange={(e) => this.handlePhoneNumberChange(e.target.value)} />
                                    <div className="header-sign-section-container-form-group-box-icon">
                                        <img src={phoneIconForm} className="header-sign-section-container-form-group-box-icon-img  header-sign-section-container-form-group-box-icon-img__phone" alt="Phone icon" />
                                    </div>
                                </div>
                            </div>
                            <div className="header-sign-section-container-form-group">
                                <label className="header-sign-section-container-form-group-label">{t('asan user id')}</label>
                                <div className="header-sign-section-container-form-group-box">
                                    <input type="text" className="header-sign-section-container-form-group-box-input" value={this.state.userId} placeholder={t('asan user id')} onChange={(e) => this.handleUserIdChange(e.target.value)} />
                                    <div className="header-sign-section-container-form-group-box-icon">
                                        <img src={userIconForm} className="header-sign-section-container-form-group-box-icon-img header-sign-section-container-form-group-box-icon-img__user" alt="User icon" />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    <div className="registration-container-validation-feedback">
                        {
                            feedbackMessage ? <p className="header-sign-section-container-form-validation-feedback-message">{feedbackMessage}</p> : null
                        }
                    </div>
                    <div className="registration-container-footer">
                        <button type="button" className="registration-container-footer-button registration-container-footer-button--left" onClick={this.backLogin}>{t('back')}</button>
                        <button className="registration-container-footer-button registration-container-footer-button--right" onClick={(e) => step === 1 ? this.checkData(e) : this.getAsanAuthForgotPass(e)} disabled={isDisabled}>{t('next')}</button>
                    </div>
                </form>
            </div>
        )
    }
}
export default translate("translation")(CheckForgotPass);